import { Component, OnInit } from '@angular/core';
import { GalaxyEmailViewerModule } from '@vendasta/galaxy/email-viewer';
import { CampaignStepSelectorComponent } from './campaign-step-selector/campaign-step-selector.component';
import { CampaignPreviewerService, PreviewStepData } from '../campaign-previewer.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CampaignStepType } from '@vendasta/campaigns';
import { ChatMessageComponent } from '@vendasta/galaxy/chat';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'campaign-step-previewer',
  standalone: true,
  templateUrl: 'campaign-step-previewer.component.html',
  styleUrls: ['campaign-step-previewer.component.scss'],
  imports: [
    CommonModule,
    GalaxyEmailViewerModule,
    CampaignStepSelectorComponent,
    MatProgressSpinner,
    ChatMessageComponent,
    GalaxyEmptyStateModule,
    MatIconModule,
  ],
  providers: [],
})
export class CampaignStepPreviewerComponent implements OnInit {
  stepTypes = CampaignStepType;
  displayData$: Observable<PreviewStepData>;

  constructor(private previewerService: CampaignPreviewerService) {}

  ngOnInit() {
    this.displayData$ = this.previewerService.getSelectedStepData();
  }
}
